export default __webpack_public_path__ + "static/media/Zügelpinguin.099b3248.jpg";